import { makePieActionObjs } from "shared/imports/pieActionGenerators"

const getPostsObjs = makePieActionObjs("get", "Posts")
export const getPosts = getPostsObjs.pieDict

const getDetailedPostObjs = makePieActionObjs("get", "Detailed_Post")
export const getDetailedPost = getDetailedPostObjs.pieDict

const createPostViewObjs = makePieActionObjs("create", "Post_View")
export const createPostView = createPostViewObjs.pieDict

const getFeaturesObjs = makePieActionObjs("get", "Features")
export const getFeatures = getFeaturesObjs.pieDict

const getFeatureObjs = makePieActionObjs("get", "Feature")
export const getFeature = getFeatureObjs.pieDict

const getFeaturePostsObjs = makePieActionObjs("get", "Feature_Posts")
export const getFeaturePosts = getFeaturePostsObjs.pieDict

const getArticleGroupsObjs = makePieActionObjs("get", "Article_Groups")
export const getArticleGroups = getArticleGroupsObjs.pieDict

const getArticleGroupObjs = makePieActionObjs("get", "Article_Group")
export const getArticleGroup = getArticleGroupObjs.pieDict

const getModulesObjs = makePieActionObjs("get", "Modules")
export const getModules = getModulesObjs.pieDict

const getModuleObjs = makePieActionObjs("get", "Module")
export const getModule = getModuleObjs.pieDict

const getModuleStepsObjs = makePieActionObjs("get", "Module_Steps")
export const getModuleSteps = getModuleStepsObjs.pieDict

const getBestPracticesObjs = makePieActionObjs("get", "Best_Practices")
export const getBestPractices = getBestPracticesObjs.pieDict

const getCaseStudiesObjs = makePieActionObjs("get", "Case_Studies")
export const getCaseStudies = getCaseStudiesObjs.pieDict

const getWhitePapersObjs = makePieActionObjs("get", "White_Papers")
export const getWhitePapers = getWhitePapersObjs.pieDict

const actionTypes = {
    ...getPostsObjs.actionTypes,
    ...getDetailedPostObjs.actionTypes,
    ...createPostViewObjs.actionTypes,
    ...getFeaturesObjs.actionTypes,
    ...getFeatureObjs.actionTypes,
    ...getFeaturePostsObjs.actionTypes,
    ...getArticleGroupsObjs.actionTypes,
    ...getArticleGroupObjs.actionTypes,
    ...getModulesObjs.actionTypes,
    ...getModuleObjs.actionTypes,
    ...getModuleStepsObjs.actionTypes,
    ...getBestPracticesObjs.actionTypes,
    ...getCaseStudiesObjs.actionTypes,
    ...getWhitePapersObjs.actionTypes,

    UPDATE_FORM_VALUE: "UPDATE_FORM_VALUE",
    CLEAR_FEATURE_SEARCH: "CLEAR_FEATURE_SEARCH",
}

export default actionTypes
